import { Modal } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faClose } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import UpgradeBtn from "../../landing/components/UpgradeBtn";

const OutOfCreditPopup = ({ open, setOpen, text, heading, userInfo }) => {
  const navigate = useNavigate();

  const handleManageSubscription = async () => {
    try {
      // Assuming you have a customerId stored in Firestore or similar
      ////({ customerId })

      const response = await axios.post(
        `${process.env.REACT_APP_SERVER_END_POINT}/create-portal`,

        { customerId: userInfo?.customer_id },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data.url) {
        window.location.href = response.data.url; // Redirect to the customer portal
      }
    } catch (error) {
      console.error("Error accessing customer portal:", error);
    }
  };
  return (
    <>
      <Modal show={open} className="success-reg-modal" centered>
        <Modal.Body>
          <div className="success-modal text-center">
            <button
              type="button"
              className="btn-close top-right-stick"
              onClick={() => {
                setOpen(false);
              }}
            >
              <FontAwesomeIcon icon={faClose} />
            </button>
            <div className="icon">
              <WarningIcon />
            </div>
            <h5>{heading}</h5>
            <p className="mb-4">{text}</p>
            {userInfo.productName !== "Gold" && (
              <div className="w-full flex justify-center">
                <UpgradeBtn setOpen={setOpen} classNames="__btn mx-auto" />
              </div>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export const WarningIcon = () => (
  <svg
    width="170"
    height="170"
    viewBox="0 0 170 170"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle opacity="0.12" cx="85" cy="84.5664" r="84.5664" fill="#F5BD62" />
    <circle cx="84.9998" cy="84.5667" r="63.2196" fill="#F5BD62" />
    <path
      opacity="0.2"
      d="M107.095 107.23H63.1788C60.0103 107.23 58.0218 103.914 59.5609 101.227L81.5192 63.0977C83.1009 60.3359 87.1733 60.3359 88.755 63.0977L110.713 101.227C112.252 103.914 110.264 107.23 107.095 107.23Z"
      fill="#FEFEFF"
    />
    <path
      d="M112.453 100.223L90.4972 62.0936C89.9485 61.1594 89.1652 60.3849 88.225 59.8467C87.2848 59.3085 86.2202 59.0254 85.1369 59.0254C84.0535 59.0254 82.9889 59.3085 82.0487 59.8467C81.1085 60.3849 80.3252 61.1594 79.7766 62.0936L57.8208 100.223C57.2929 101.127 57.0146 102.154 57.0146 103.201C57.0146 104.247 57.2929 105.275 57.8208 106.178C58.3624 107.118 59.1443 107.897 60.0863 108.435C61.0283 108.973 62.0964 109.25 63.181 109.239H107.093C108.176 109.249 109.244 108.971 110.185 108.434C111.126 107.896 111.907 107.118 112.448 106.178C112.977 105.275 113.256 104.248 113.257 103.202C113.257 102.155 112.98 101.127 112.453 100.223ZM108.971 104.167C108.779 104.494 108.504 104.764 108.174 104.949C107.844 105.134 107.471 105.228 107.093 105.222H63.181C62.8026 105.228 62.4293 105.134 62.0993 104.949C61.7693 104.764 61.4945 104.494 61.3031 104.167C61.1297 103.874 61.0382 103.539 61.0382 103.198C61.0382 102.857 61.1297 102.523 61.3031 102.229L83.2589 64.0996C83.4542 63.7747 83.7302 63.5058 84.0602 63.3191C84.3901 63.1324 84.7628 63.0343 85.1419 63.0343C85.521 63.0343 85.8937 63.1324 86.2236 63.3191C86.5536 63.5058 86.8296 63.7747 87.0249 64.0996L108.981 102.229C109.153 102.524 109.242 102.859 109.241 103.2C109.239 103.541 109.146 103.875 108.971 104.167ZM83.1283 89.1536V79.1109C83.1283 78.5782 83.3399 78.0674 83.7166 77.6907C84.0933 77.314 84.6042 77.1024 85.1369 77.1024C85.6696 77.1024 86.1804 77.314 86.5571 77.6907C86.9338 78.0674 87.1454 78.5782 87.1454 79.1109V89.1536C87.1454 89.6863 86.9338 90.1972 86.5571 90.5739C86.1804 90.9505 85.6696 91.1622 85.1369 91.1622C84.6042 91.1622 84.0933 90.9505 83.7166 90.5739C83.3399 90.1972 83.1283 89.6863 83.1283 89.1536ZM88.1497 98.192C88.1497 98.7879 87.973 99.3704 87.6419 99.8659C87.3109 100.361 86.8403 100.747 86.2898 100.976C85.7393 101.204 85.1335 101.263 84.5491 101.147C83.9647 101.031 83.4278 100.744 83.0065 100.322C82.5851 99.9011 82.2982 99.3642 82.1819 98.7798C82.0657 98.1954 82.1254 97.5896 82.3534 97.0391C82.5814 96.4886 82.9676 96.018 83.463 95.687C83.9585 95.3559 84.541 95.1792 85.1369 95.1792C85.9359 95.1792 86.7022 95.4966 87.2672 96.0617C87.8322 96.6267 88.1497 97.393 88.1497 98.192Z"
      fill="#FEFEFF"
    />
  </svg>
);

export default OutOfCreditPopup;
